import { render, staticRenderFns } from "./individual.vue?vue&type=template&id=4b03097a&"
import script from "./individual.vue?vue&type=script&lang=js&"
export * from "./individual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports